<template>
  <two-column-layout
      :id="$route.params.id"
      back-button-tab-selector="AttachmentPointbackbutton"
      sub-menu-selector="librarypanel"
      tab-selector="AttachmentPointtab"
      type="AttachmentPoint"
  >
    <div slot="buttonsLeft"/>

    <info-panel
        :id="$route.params.id"
        slot="sidebarLeft"
        :created="$store.getters.getAttachmentPointCreationDate(id)"
        :downloadable="true"
        :last-change="$store.getters.getAttachmentPointChangeDate(id)"
        :organization="$store.getters.getAttachmentPointOrganization($route.params.id)"
        :upload-type="'Asset'"
        preview-id="AttachmentPointEdit"
    />
    <info-panel
        :id="$route.params.id"
        :key="'infopanel2'"
        slot="sidebarLeft"
        :limit-tags-to-organization="$store.getters.getAttachmentPointOrganization($route.params.id)"
        :taggable="hasWritingAccess"
        :tags="$store.getters.getAttachmentPointTags($route.params.id)"
        preview-id="AttachmentPointEdit"
        @addTag="addTag"
        @removeTag="removeTag"
    />
    <team-attacher
        v-if="$store.getters.getAttachmentPointOrganization($route.params.id)"
        :id="$route.params.id"
        slot="sidebarLeft"
        :limit-by-organization-id="$store.getters.getAttachmentPointOrganization($route.params.id)"
        :teams="teams"
        :read-only="!hasWritingAccess"
        class="mt-3"
        store-name="Asset"
        @added="loadAssetTeams"
        @removed="loadAssetTeams"
    />

    <div slot="mainContent">
      <name-display-edit-block
          :id="$route.params.id"
          :organization-id="$store.getters.getAttachmentPointOrganization($route.params.id)"
          :name="$store.getters.getAttachmentPointName(id)"
          :display-name="$store.getters.getAttachmentPointDisplayName(id)"
          store-name="AttachmentPoint" />
      <content-description-block
          :id="$route.params.id"
          :value="$store.getters.getAttachmentPointDescription(id)"
          store-name="AttachmentPoint"
      />
      <div class="row">
        <state-setter
            :given-state="$store.getters.getAttachmentPointState($route.params.id)"
            :target-id="$route.params.id"
            class="col-12 col-md-4 mb-2 mt-2"
            store-name="AttachmentPoint"
        />
      </div>

      <div class="row">
        <div class="w-100"/>
        <div class="col-12 col-md-6 no-gutters">
          <info-panel
              v-if="$store.getters.isSuperAdmin"
              :collapsible="true"
              :initially-collapsed="true"
              info-panel-header="sfx edit"
              preview-id="metasetattacher"
          >
            <meta-set-attacher
                slot="info"
                :given-meta-sets="$store.getters.getAttachmentPointMetaSets(id)"
                :target-id="$route.params.id"
                store-name="Asset"
                @added="loadAttachmentPoint"
                @removed="loadAttachmentPoint"
            />
          </info-panel>
        </div>
        <meta-panel
            v-for="(item) in $store.getters.getAttachmentPointMetaSets(id)"
            :key="item.id"
            :fields="item.metaFields"
            :organization-ids="[$store.getters.getAttachmentPointOrganization(id)]"
            :title="item.description"
            class="col-12 col-md-6"
            icon-left="folder"
            store-name="AttachmentPoint"
            @updated="loadAttachmentPoint"
        />
      </div>
    </div>
  </two-column-layout>
</template>

<script>
import InfoPanel from "../components/InfoPanel";
import TwoColumnLayout from "../layouts/OneColumnSidebarLeft";
import MetaPanel from "../components/widgets/meta/MetaPanel";
import ContentDescriptionBlock from "../components/ContentDescriptionBlock";
import MetaSetAttacher from "@/components/widgets/meta/MetaSetAttacher";
import TeamAttacher from "@/components/organizations/TeamAttacher";
import StateSetter from "@/components/StateSetter";
import NameDisplayEditBlock from "@/components/NameDisplayEditBlock.vue";

export default {
  name: 'AttachmentPointEdit',
  components: {
    MetaPanel,
    InfoPanel,
    TwoColumnLayout,
    ContentDescriptionBlock,
    MetaSetAttacher,
    TeamAttacher,
    StateSetter,
    NameDisplayEditBlock
  },
  data() {
    return {
      id: '',
      teams: [],
      hasWritingAccess: false,
    };
  },
  beforeMount() {
    this.loadAttachmentPoint();
    this.id = this.$route.params.id;
    this.loadAssetTeams();
  },
  methods: {
    async checkAccess(asset) {
      const hasAccess = await this.$store.dispatch('checkTeamOrgPermission', {
        op: 'read',
        teams: asset.teams,
        organizationId: asset.organizationId
      })
      this.hasWritingAccess = await this.$store.dispatch('checkTeamOrgPermission', {
        op: 'write',
        teams: asset.teams,
        organizationId: asset.organizationId
      })
      if (!hasAccess) {
        this.denyAccess();
      }
    },
    loadAssetTeams() {
      this.$store.dispatch('clientLoadAssetTeams', {
        id: this.$route.params.id
      }).then(data => {
        this.teams = data;
      });
    },
    loadAttachmentPoint() {
      this.$store.dispatch('loadAttachmentPoint', {
        id: this.$route.params.id,
        include: 'metaSets,tags'
      }).then(AttachmentPoint => {
        this.checkAccess(AttachmentPoint);
        // todo: this is a temporary fix, find a permanent solution for type specific edit links
      }).catch(e => {
        if (e.status === 401) {
          this.$router.push('/access-denied');
        } else if (e.status === 404) {
          this.$router.push('/not-found')
        }
      });
    },
    removeTag: function (tag) {
      this.$store.dispatch('removeAttachmentPointTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
    addTag: function (tag) {
      this.$store.dispatch('addAttachmentPointTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
  },
}
</script>